import React, { useState } from "react";
import "./style.css";
import Table from "react-bootstrap/Table";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function CreateUmbrella({ clientID, carrierData, agents }) {
  const [formData, setFormData] = useState({
    policyNumber: "",
    carrier: "",
    effectiveDate: "",
    clientFirstName: "",
    clientLastName: "",
    liability: "",
    premium: "",
    mainAgent: "",
    mainAgentSplit: "",
    refAgentOne: "",
    refAgentOneSplit: "",
    refAgentTwo: "",
    refAgentTwoSplit: "",
    refAgentThree: "",
    refAgentThreeSplit: "",
    refAgentFour: "",
    refAgentFourSplit: "",
    declaration: "",
    carrierData: "",
    docName: "",
    document: ""
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    console.log(event.target.files);
    setFormData((prev) => ({ ...prev, docName: event.target.files[0].name }));

    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({ ...prev, document: res }));
      });
    }
  };

  const handlePolicyCreate = (event) => {
    event.preventDefault();

    const umbrellaInformation = {
      policyNumber: formData.policyNumber,
      carrier: formData.carrier,
      effectiveDate: formData.effectiveDate,
      clientFirstName: formData.clientFirstName,
      clientLastName: formData.clientLastName,
      clientID: clientID,
      liability: formData.liability,
      premium: formData.premium,
      mainAgent: formData.mainAgent,
      mainAgentSplit: formData.mainAgentSplit,
      refAgentOne: formData.refAgentOne,
      refAgentOneSplit: formData.refAgentOneSplit,
      refAgentTwo: formData.refAgentTwo,
      refAgentTwoSplit: formData.refAgentTwoSplit,
      refAgentThree: formData.refAgentThree,
      refAgentThreeSplit: formData.refAgentThreeSplit,
      refAgentFour: formData.refAgentFour,
      refAgentFourSplit: formData.refAgentFourSplit,
      declaration: formData.declaration
    };

    API.saveUmbrellaPolicy(clientID, {
      policyNumber: formData.policyNumber,
      carrier: formData.carrier,
      effectiveDate: formData.effectiveDate,
      clientFirstName: formData.clientFirstName,
      clientLastName: formData.clientLastName,
      clientID: clientID,
      liability: formData.liability,
      premium: formData.premium,
      mainAgent: formData.mainAgent,
      mainAgentSplit: formData.mainAgentSplit,
      refAgentOne: formData.refAgentOne,
      refAgentOneSplit: formData.refAgentOneSplit,
      refAgentTwo: formData.refAgentTwo,
      refAgentTwoSplit: formData.refAgentTwoSplit,
      refAgentThree: formData.refAgentThree,
      refAgentThreeSplit: formData.refAgentThreeSplit,
      refAgentFour: formData.refAgentFour,
      refAgentFourSplit: formData.refAgentFourSplit,
      declaration: formData.declaration
    })
      .then((res) => {
        console.log("Saved Umbrella Policy");
        console.log(res.data);
        cogoToast.success("Saved Umbrella Policy");
        if (formData.document.length > 0) {
          if (formData.docName.length > 0) {
            API.createDocumentForUmbrella(res.data._id, {
              docName: formData.docName,
              document: formData.document,
              policyid: res.data._id,
              type: "umbrella"
            })
              .then((_res) => {
                console.log(_res.data);
                cogoToast.success("Uploaded Umbrella Document!");
              })
              .catch((_err) => console.log(_err));
          } else {
            API.createDocumentForUmbrella(res.data._id, {
              docName: "Umbrella Document",
              document: formData.document,
              policyid: res.data._id,
              type: "umbrella"
            })
              .then((_res) => {
                console.log(_res.data);
                cogoToast.success("Uploaded Umbrella Document!");
              })
              .catch((_err) => console.log(_err));
          }
        }
      })
      .catch((_err) => console.log(_err));

    console.log(umbrellaInformation);
  };

  return (
    <div>
      <div className="card">
        <h5 style={{ textAlign: "center" }}>Create an Umbrella Policy</h5>
        <div className="card-body">
          <form>
            <Table bordered hover>
              <tbody>
                <tr>
                  <th>Data</th>
                  <th>Input</th>
                </tr>

                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Policy Number
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.policyNumber}
                      onChange={handleInputChange}
                      name="policyNumber"
                      placeholder="Policy Number"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Carrier
                  </td>
                  <td>
                    {carrierData ? (
                      <select
                        id="carrierDropMenu"
                        value={formData.carrier}
                        onChange={handleInputChange}
                        name="carrier"
                      >
                        <option value="">--Select a Carrier--</option>
                        {carrierData.map((carrier) => (
                          <option key={carrier._id} value={carrier.name}>
                            {carrier.name}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <div>No Carriers yet, *Go to Create Carrier option in Admin Tools</div>
                    )}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Effective Date
                  </td>
                  <td>
                    <input
                      type="date"
                      value={formData.effectiveDate}
                      onChange={handleInputChange}
                      name="effectiveDate"
                      placeholder="Effective Date"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Client First Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.clientFirstName}
                      onChange={handleInputChange}
                      name="clientFirstName"
                      placeholder="Client First Name"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Client Last Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.clientLastName}
                      onChange={handleInputChange}
                      name="clientLastName"
                      placeholder="Client Last Name"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Excess Liability
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.liability}
                      onChange={handleInputChange}
                      name="liability"
                      placeholder="Personal Liability Limits"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Premium
                  </td>
                  <td>
                    <input
                      type="number"
                      value={formData.premium}
                      onChange={handleInputChange}
                      name="premium"
                      placeholder="Premium"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Declarations
                  </td>
                  <td>
                    <input type="file" name="fileData" onChange={fileSelectedHandler} />
                  </td>
                </tr>
              </tbody>
            </Table>
            <Table>
              <tbody>
                <tr>
                  <th>Item Name</th>
                  <th>Agent</th>
                  <th>Split</th>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Main Agent
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.mainAgent}
                          onChange={handleInputChange}
                          name="mainAgent"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.mainAgent ? (
                      <input
                        type="number"
                        value={formData.mainAgentSplit}
                        name="mainAgentSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #1
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentOne}
                          onChange={handleInputChange}
                          name="refAgentOne"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentOne ? (
                      <input
                        type="number"
                        value={formData.refAgentOneSplit}
                        name="refAgentOneSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #2
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentTwo}
                          onChange={handleInputChange}
                          name="refAgentTwo"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentTwo ? (
                      <input
                        type="number"
                        value={formData.refAgentTwoSplit}
                        name="refAgentTwoSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #3
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentThree}
                          onChange={handleInputChange}
                          name="refAgentThree"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentThree ? (
                      <input
                        type="number"
                        value={formData.refAgentThreeSplit}
                        name="refAgentThreeSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #4
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentFour}
                          onChange={handleInputChange}
                          name="refAgentFour"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentFour ? (
                      <input
                        type="number"
                        value={formData.refAgentSplitFour}
                        name="refAgentSplitFour"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
              </tbody>
            </Table>
            <div style={{ textAlign: "center" }}>
              <button className="btn-success btn-sm btn" onClick={handlePolicyCreate}>
                Create Policy
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateUmbrella;
